import { render, staticRenderFns } from "./StepIcon.vue?vue&type=template&id=a7965734&"
import script from "./StepIcon.vue?vue&type=script&lang=ts&"
export * from "./StepIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports